import React from 'react';
import MarkdownEditor from '../Common/MarkdownEditor';

interface SimpleTextareaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'onChange'> {
  // Pas de props spécifiques à react-hook-form (label, name, register, error)
  // Les props standard comme value, onChange, placeholder, rows, className, id sont héritées
  markdown?: boolean; // Enable/disable markdown mode (default: true)
  preview?: 'edit' | 'live' | 'preview'; // Preview mode for markdown editor
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const SimpleTextarea: React.FC<SimpleTextareaProps> = ({ 
  className, 
  markdown = true,
  preview = 'live',
  value,
  onChange,
  rows,
  ...rest 
}) => {
  const handleMarkdownChange = React.useCallback((val: string | undefined) => {
    if (onChange) {
      // Create a synthetic event for compatibility
      const syntheticEvent = {
        target: { value: val || '' },
        currentTarget: { value: val || '' },
      } as React.ChangeEvent<HTMLTextAreaElement>;
      onChange(syntheticEvent);
    }
  }, [onChange]);

  if (markdown) {
    return (
      <MarkdownEditor
        value={value || ''}
        onChange={handleMarkdownChange}
        preview={preview}
        placeholder={rest.placeholder}
        disabled={rest.disabled}
        className={className}
        height={rows ? rows * 20 : 200}
      />
    );
  }

  return (
    <textarea
      {...rest}
      value={value}
      onChange={onChange}
      className={`block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm ${className || ''}`}
    />
  );
};

export default SimpleTextarea;
